//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/** The costs that a adjustment should affect */
export var AdjustmentAffects;
(function (AdjustmentAffects) {
    AdjustmentAffects["DeliveryCost"] = "DeliveryCost";
    AdjustmentAffects["ProductCost"] = "ProductCost";
    AdjustmentAffects["MealCost"] = "MealCost";
    AdjustmentAffects["Subtotal"] = "Subtotal";
    AdjustmentAffects["Total"] = "Total";
})(AdjustmentAffects || (AdjustmentAffects = {}));
/** The way in which the adjustment is applied */
export var AdjustmentApplication;
(function (AdjustmentApplication) {
    AdjustmentApplication["None"] = "None";
    AdjustmentApplication["Percent"] = "Percent";
    AdjustmentApplication["Dollars"] = "Dollars";
    AdjustmentApplication["PerMeal"] = "PerMeal";
})(AdjustmentApplication || (AdjustmentApplication = {}));
/** The way in which the adjustment adjusts the total cost */
export var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType["Discount"] = "Discount";
    AdjustmentType["Surcharge"] = "Surcharge";
})(AdjustmentType || (AdjustmentType = {}));
/** The way in which a adjustment is invalid or valid */
export var AdjustmentValidation;
(function (AdjustmentValidation) {
    AdjustmentValidation["Invalid"] = "Invalid";
    AdjustmentValidation["Expired"] = "Expired";
    AdjustmentValidation["Used"] = "Used";
    AdjustmentValidation["First_Order_Only"] = "First Order Only";
    AdjustmentValidation["Subscriptions_Only"] = "Subscriptions Only";
    AdjustmentValidation["Trials_Only"] = "Trials Only";
    AdjustmentValidation["Below_Min_Cost"] = "Below Min Cost";
    AdjustmentValidation["Valid"] = "Valid";
})(AdjustmentValidation || (AdjustmentValidation = {}));
/** Status of a section of the company wizard */
export var CompanyWizardStatus;
(function (CompanyWizardStatus) {
    CompanyWizardStatus["NotStarted"] = "NotStarted";
    CompanyWizardStatus["Started"] = "Started";
    CompanyWizardStatus["Completed"] = "Completed";
})(CompanyWizardStatus || (CompanyWizardStatus = {}));
/** The configurable sections */
export var ConfigurationSection;
(function (ConfigurationSection) {
    ConfigurationSection["Company"] = "Company";
    ConfigurationSection["PaymentProcessor"] = "PaymentProcessor";
    ConfigurationSection["GeneralSettings"] = "GeneralSettings";
})(ConfigurationSection || (ConfigurationSection = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
/** Enums used to express the type of cut off date to be retreived. */
export var GetCutOffDateTimeRequestType;
(function (GetCutOffDateTimeRequestType) {
    GetCutOffDateTimeRequestType["PreferRenewalCutOffs"] = "PreferRenewalCutOffs";
    GetCutOffDateTimeRequestType["PreferOrderCutOffs"] = "PreferOrderCutOffs";
    GetCutOffDateTimeRequestType["RenewalCutOffsOnly"] = "RenewalCutOffsOnly";
    GetCutOffDateTimeRequestType["OrderCutOffsOnly"] = "OrderCutOffsOnly";
})(GetCutOffDateTimeRequestType || (GetCutOffDateTimeRequestType = {}));
/** The type of image in storage */
export var ImageType;
(function (ImageType) {
    ImageType["Untracked"] = "Untracked";
    ImageType["NutritionalLabel"] = "NutritionalLabel";
    ImageType["Recipe"] = "Recipe";
    ImageType["CompanyLogo"] = "CompanyLogo";
})(ImageType || (ImageType = {}));
/** The source of an Order */
export var OrderSource;
(function (OrderSource) {
    OrderSource["ManualEntry"] = "ManualEntry";
    OrderSource["Renew"] = "Renew";
    OrderSource["FromImport"] = "FromImport";
    OrderSource["MealTrack2"] = "MealTrack2";
    OrderSource["OrderFlow"] = "OrderFlow";
    OrderSource["CustomFrontend"] = "CustomFrontend";
    OrderSource["Mobile"] = "Mobile";
    OrderSource["Unknown"] = "Unknown";
})(OrderSource || (OrderSource = {}));
/** The status of an order */
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Pending"] = "Pending";
    OrderStatus["Active"] = "Active";
    OrderStatus["Complete"] = "Complete";
    OrderStatus["Cancelled"] = "Cancelled";
    OrderStatus["Future"] = "Future";
})(OrderStatus || (OrderStatus = {}));
/** The type of the way in which payments are transferred */
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Unknown"] = "Unknown";
    PaymentMethodType["Offline"] = "Offline";
    PaymentMethodType["Card"] = "Card";
    PaymentMethodType["GiftCard"] = "GiftCard";
})(PaymentMethodType || (PaymentMethodType = {}));
/** The supported payment processors within MealTrack */
export var PaymentProcessor;
(function (PaymentProcessor) {
    PaymentProcessor["Unknown"] = "unknown";
    PaymentProcessor["Stripe"] = "stripe";
    PaymentProcessor["Authorize_net"] = "authorize_net";
    PaymentProcessor["Tap"] = "tap";
})(PaymentProcessor || (PaymentProcessor = {}));
/** The Security Level of a User. */
export var SecurityLevel;
(function (SecurityLevel) {
    SecurityLevel["SystemAdmin"] = "SystemAdmin";
    SecurityLevel["SuperAdmin"] = "SuperAdmin";
    SecurityLevel["CompanyAdmin"] = "CompanyAdmin";
    SecurityLevel["CustomerService"] = "CustomerService";
    SecurityLevel["KitchenUser"] = "KitchenUser";
    SecurityLevel["Customer"] = "Customer";
})(SecurityLevel || (SecurityLevel = {}));
/** The status of a subscription order */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["None"] = "none";
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["Paused"] = "paused";
    SubscriptionStatus["Complete"] = "complete";
    SubscriptionStatus["Cancelled"] = "cancelled";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Represents measurement units for ingredients. */
export var Units;
(function (Units) {
    Units["Oz"] = "Oz";
    Units["Lbs"] = "Lbs";
    Units["Gal"] = "Gal";
    Units["Tsp"] = "Tsp";
    Units["Tbsp"] = "Tbsp";
    Units["Each"] = "Each";
    Units["Cup"] = "Cup";
    Units["Slice"] = "Slice";
    Units["ToTaste"] = "ToTaste";
    Units["Floz"] = "Floz";
    Units["Gram"] = "Gram";
    Units["Serving"] = "Serving";
    Units["Package"] = "Package";
    Units["Bunch"] = "Bunch";
    Units["Sprig"] = "Sprig";
    Units["Quart"] = "Quart";
    Units["Head"] = "Head";
    Units["Pint"] = "Pint";
    Units["Loave"] = "Loave";
    Units["Jar"] = "Jar";
    Units["Can"] = "Can";
    Units["Liter"] = "Liter";
    Units["Ml"] = "Ml";
    Units["Kg"] = "Kg";
})(Units || (Units = {}));
